import {
  HIDE_ASSETS_MODAL,
  SHOW_ASSETS_MODAL,
  UPLOAD_ASSET_FAILURE,
  UPLOAD_ASSET_REQUEST,
  UPLOAD_ASSET_SUCCESS,
  FETCH_ASSETS_REQUEST,
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAILURE,
  DELETE_ASSET_REQUEST,
  DELETE_ASSET_SUCCESS,
  DELETE_ASSET_FAILURE,
  DELETE_ALL_ASSETS_REQUEST,
  UPDATE_ASSET_REQUEST,
  UPDATE_ASSET_SUCCESS,
  UPDATE_ASSET_FAILURE,
} from '../../constant';
import { API_URLS, API_METHODS } from '../../constant/apiEndPoints';
import { invoke } from '../../helpers/apiRequest';

export const showAssetsModal = () => (dispatch) => {
  dispatch({
    type: SHOW_ASSETS_MODAL,
    open: true,
  });
};

export const hideAssetsModal = () => (dispatch) => {
  dispatch({
    type: HIDE_ASSETS_MODAL,
    open: false,
  });
};

export const uploadAsset = (payload) => async (dispatch) => {
  dispatch({ type: UPLOAD_ASSET_REQUEST });
  console.log('uploading asset', payload);
  const { file, name, users } = payload;
  const formData = new FormData();
  formData.append('file', file);
  if (name) {
    formData.append('name', name);
  } else {
    formData.append('name', file.name);
  }
  if (users) {
    users.forEach((user, index) => {
      formData.append(`users_access[${index}]`, user);
    });
  }
  try {
    const response = await invoke({ url: API_URLS.ASSETS, type: API_METHODS.POST }, formData);
    dispatch({ type: UPLOAD_ASSET_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: UPLOAD_ASSET_FAILURE, error });
  }
};

export const fetchAssets = () => async (dispatch) => {
  dispatch({ type: FETCH_ASSETS_REQUEST });
  try {
    const response = await invoke({
      url: API_URLS.ASSETS,
      type: API_METHODS.GET,
    });
    dispatch({ type: FETCH_ASSETS_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: FETCH_ASSETS_FAILURE, error });
  }
};

export const fetchAllAssets = () => async (dispatch) => {
  dispatch({ type: FETCH_ASSETS_REQUEST });
  try {
    const response = await invoke({
      url: API_URLS.ASSETS_ALL,
      type: API_METHODS.GET,
    });
    dispatch({ type: FETCH_ASSETS_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: FETCH_ASSETS_FAILURE, error });
  }
};

export const deleteAsset = (assetId) => async (dispatch) => {
  dispatch({ type: DELETE_ASSET_REQUEST, payload: assetId });
  try {
    await invoke({ url: `${API_URLS.ASSETS}/${assetId}`, type: API_METHODS.DELETE });
    dispatch({ type: DELETE_ASSET_SUCCESS, payload: assetId });
    dispatch(fetchAssets());
  } catch (error) {
    dispatch({ type: DELETE_ASSET_FAILURE, error });
  }
};

export const deleteAllAssets = (assetId) => async (dispatch) => {
  dispatch({ type: DELETE_ALL_ASSETS_REQUEST, payload: assetId });
  try {
    await invoke({ url: `${API_URLS.ASSETS}/${assetId}/all`, type: API_METHODS.DELETE });
    dispatch({ type: DELETE_ASSET_SUCCESS, payload: assetId });
    dispatch(fetchAllAssets());
  } catch (error) {
    dispatch({ type: DELETE_ASSET_FAILURE, error });
  }
};

export const updateAsset = (payload) => async (dispatch) => {
  dispatch({ type: UPDATE_ASSET_REQUEST, payload });
  const { file, name, users, id } = payload;
  const formData = new FormData();
  formData.append('file', file);
  if (name) {
    formData.append('name', name);
  } else {
    formData.append('name', file.name);
  }
  if (users) {
    users.forEach((user, index) => {
      formData.append(`users_access[${index}]`, user);
    });
  }
  try {
    const response = await invoke({ url: `${API_URLS.ASSETS}/${id}`, type: API_METHODS.POST }, formData);
    dispatch({ type: UPDATE_ASSET_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: UPDATE_ASSET_FAILURE, error });
  }
};
